'use client';

import Link from 'next/link';

export default function HomeError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="root-status-page">
      <section className="root-status-card">
        <p className="root-status-code">Error</p>
        <h1>Something went wrong</h1>
        <p>We encountered an error while loading the home page.</p>
        <button type="button" onClick={reset} style={{ minHeight: '44px' }}>
          Try again
        </button>
        <p>
          <Link href="/en/home">Return Home</Link>
        </p>
      </section>
    </main>
  );
}
